import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rp9e5zdxjc: FaireBrandEntity = {
  token: "b_rp9e5zdxjc",
  type: "brand",
  name: "Wilkin & May",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb6ae27b37896de67320507dbcf25ce3edc99c921684fb54e0969e995aec757f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/728127f46ca9952e51cc490af1f3dd8a5ebb1bef78463ed302b896d9b6e25a6d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb6ae27b37896de67320507dbcf25ce3edc99c921684fb54e0969e995aec757f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/728127f46ca9952e51cc490af1f3dd8a5ebb1bef78463ed302b896d9b6e25a6d.jpeg",
  location: "Los Angeles , CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    'Wilkin & May is a modern fragrance house creating clean, earth-based scents for those who crave beauty in simplicity. Rooted in ritual and refinement, each fragrance is designed to bring depth and understated luxury to the everyday, where minimalism meets memory and scent becomes a form of presence.\n\nThe brand began with a musician’s sensitivity to atmosphere, a love for how scent, sound, and texture can shape emotion, create or unlock a memory, and bring us back to center. When Steven first blended a fragrance for himself, strangers would stop to ask "what are you wearing!?". That simple curiosity became the foundation of Wilkin & May, now a collection of six thoughtfully crafted scents designed to move through life like a melody.\n\nWe are a team of two, handcrafting every product in-house with care and intention. Each formula is free from toxins, phthalates, and harsh synthetics, made to feel as pure as it smells.\n\nWe value our stockists and partners deeply. Every collaboration is personal, built on shared values of quality, authenticity, and beauty made well.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:24.823Z",
    importedBy: "entity-db-cli",
  },
};
